import React, {Fragment, useState} from 'react';

import {FORM_CONTROL_PROPS_GENERATOR as controlProps} from '../../../../../constants';
import Input from '../../../../UI/Input/Input';
import PageTitle from '../../../../UI/PageTitle/PageTitle';

const Password = props => {

    const [currentState, modifyState] = useState({
        passwordSettingsForm: {
            loginAttempts: controlProps('input', {
                type: 'text',
                id: 'Failed logins before account blocking',
            }, ''),
            passwordLength: controlProps('input', {
                type: 'text',
                id: 'Password length',
                name: 'password'
            }, ''),
            expiryPeriod: controlProps('input', {
                type: 'text',
                id: 'Expiry period in days'
            }, ''),
            periodBeforeReuse: controlProps('input', {
                type: 'text',
                id: 'Period in days before an old password can be re-used'
            }, ''),
            minimumLowerCaseCharacters: controlProps('input', {
                type: 'text',
                id: 'Minimum lowercase characters'
            }, ''),
            minimumUpperCaseCharacters: controlProps('input', {
                type: 'text',
                id: 'Minimum upercase characters'
            }, ''),
            minimumNumbers: controlProps('input', {
                type: 'number',
                id: 'Minimum number characters'
            }, ''),
            minimumSpecialCharacters: controlProps('input', {
                type: 'number',
                id: 'Minimum special characters'
            }, ''),
            reusePassword: controlProps('checkbox', {
                type: 'checkbox',
                id: 'Period in days before an old password can be re-used'
            }, '')
        }
    });

    const passwordSettingsFormElementsArray = [];

    for(let key in currentState.passwordSettingsForm) {
        passwordSettingsFormElementsArray.push({
            id: key,
            config: currentState.passwordSettingsForm[key]
        });
    }

    const inputChangedHandler = (event, inputIdentifier) => {
        const updatedPasswordSettingsForm = {
            ...currentState.passwordSettingsForm
        };

        const updatedPasswordSettingsFormElement = {
            ...updatedPasswordSettingsForm[inputIdentifier]
        };

        updatedPasswordSettingsFormElement.value = event.target.value;

        updatedPasswordSettingsForm[inputIdentifier] = updatedPasswordSettingsFormElement;

        return modifyState({
            ...currentState,
            loginForm: updatedPasswordSettingsForm
        });
    }

    return (
        <Fragment>
            <PageTitle title='Password settings' search={false} />
            <div className="page-content">
                <form autoComplete="off" id="loginForm">
                    <div className="row" data-plugin="formMaterial">
                        {passwordSettingsFormElementsArray.map(formElement => {
                            return (
                                <div key={formElement.id} className="col-md-6">
                                    <Input formcontrol={formElement.config.formControl} formControlConfig={formElement.config.formControlConfig} value={formElement.config.value} changed={(event) => inputChangedHandler(event, formElement.id)} />
                                </div>
                            );
                        })}
                        {currentState.signinButton}
                    </div>
                    <button className="btn btn-raised btn-primary">Submit</button>
                </form>
            </div>
        </Fragment>
    );

}

export default Password;